import styled from "styled-components";
import colors from "../../../../styles/colors";
import * as React from "react";
import ClickableElement from "../../../utils/ClickableElement";
import { IoIosClose } from "react-icons/io";
import ToolTip from "react-tooltip";

interface IMoreButtonProps {
  onClick: () => void;
  isOpenText: boolean;
}

const CloseTextButtonContainer = styled(ClickableElement as any)<IMoreButtonProps>`
  display: ${props => (props.isOpenText ? "flex" : "none")};
  background-color: rgba(0, 0, 0, 0);
  width: fit-content;
  position: absolute;
  top: 5px;
  right: 5px;
`;

const MoreButtonContainer = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 0;

  > .__react_component_tooltip {
    border-radius: 7px;
    box-shadow: 0.2rem 0.2rem 0.5rem 0 rgba(0, 0, 0, 0.25);
  }
`;

const MoreButtonClickableArea = styled(ClickableElement as any)<IMoreButtonProps>`
  width: fit-content;
  height: auto;
  display: ${props => (props.isOpenText ? "none" : "block")};

  > svg:hover {
    filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.25));
  }
`;

export const More = styled.div`
  background: ${colors.chartLightBlue20};
  border-radius: 8px;
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 2rem 2rem 3rem;

  > p {
    margin-block-end: 0px;
  }
`;

const MoreButtonIcon: React.FC<{ color: string }> = ({ color }) => (
  <svg
    data-testid="more-btn-icon"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.3867 22.8398C17.9096 22.8398 22.3867 18.3627 22.3867 12.8398C22.3867 7.317 17.9096 2.83984 12.3867 2.83984C6.86387 2.83984 2.38672 7.317 2.38672 12.8398C2.38672 18.3627 6.86387 22.8398 12.3867 22.8398Z"
      fill="white"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M12.3867 8.83984V16.8398" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8.38672 12.8398H16.3867" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const MoreButton = (props: IMoreButtonProps) => {
  const [showTooltip, toggleTooltip] = React.useState(true);

  const toggleShowTooltip = (value: boolean) => {
    return (event: React.MouseEvent) => {
      toggleTooltip(value);
      event.preventDefault();
    };
  };

  return (
    <>
      <MoreButtonContainer>
        <MoreButtonClickableArea
          onClick={props.onClick}
          isOpenText={props.isOpenText}
          data-for="more-tooltip"
          data-tip=""
          onMouseEnter={toggleShowTooltip(true)}
          onMouseLeave={toggleShowTooltip(false)}
        >
          <MoreButtonIcon color={colors.chartLightBlue100} />
        </MoreButtonClickableArea>
        <ToolTip place="top" id="more-tooltip" backgroundColor={colors.chartDarkBlue100}>
          {showTooltip && <b>More information</b>}
        </ToolTip>
      </MoreButtonContainer>
    </>
  );
};

export const CloseHelpTextButton = (props: IMoreButtonProps) => {
  return (
    <CloseTextButtonContainer onClick={props.onClick} isOpenText={props.isOpenText}>
      <IoIosClose data-testid="close-text-btn" style={{ width: "3.5rem", height: "auto" }} />
    </CloseTextButtonContainer>
  );
};

export default MoreButton;
